<template>
  <input
    @change="onFilesUpload"
    ref="transfer_upload_input"
    id="editorFileUpload"
    type="file"
    hidden
    multiple
  >
</template>

<script setup>
  import {ref}                       from "vue";
  import {defineExpose, defineProps} from "vue";
  import FilesEventManager           from "@/js/Shared/Events/Managers/FilesEventManager";

  const props = defineProps({
    compose_controller : {
      required: true,
    }
  })

  const transfer_upload_input = ref();

  const onFilesUpload = (event) => {
    props.compose_controller.addSapoTransferFiles(
      FilesEventManager.createFilesEvent(event.target.files),
    )
  }

  const triggerUpload = () => {
    transfer_upload_input.value.click();
  }

  defineExpose({
    upload : triggerUpload,
  })
</script>